import React from 'react';
import { Flex, Modal , Typography } from 'antd';
import imaLogo from '../../images/logos/ima.png';

const { Text } = Typography;

const ImaModal = ({setIsModalOpen, isModalOpen}) => {

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Flex align='center' justify='center'>
       <Modal
        title="Assistance coordinator"
        centered
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={{
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%',
        }}
      >
        <Text>
          <br />
          For a couple of summers I have worked as an assistance coordinator at Inter Mutuelles Assistance. 
          In this role, I provided telephone assistance to insured individuals facing unexpected situations, primarily focusing on vehicle-related issues. 
          My responsibilities included:
          <br />
          <br />
          • <strong>Assessing and addressing emergencies</strong> such as vehicle breakdowns on rural roads.<br />
          • <strong>Analysing insurance contracts</strong> to determine coverage and appropriate assistance.<br />
          • <strong>Coordinating real-time assistance services</strong> like towing, roadside repair, and taxi or hotel reservations.<br />
          • <strong>Reassuring and guiding clients</strong> through stressful situations.<br />
          <br />
          <br />
          This experience allowed me to develop strong problem-solving skills, improve my ability to handle urgent situations, and enhance my customer service expertise in a fast-paced environment.
          Additionally, I became proficient in using specialized software and gained adaptability in managing diverse client needs.
        </Text>
        <Flex justify='end'><img src={imaLogo} alt='ima-logo' width='200px' /></Flex>
        
      </Modal>
    </Flex>
  );
};

export default ImaModal;